import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "rosterName",
    standalone: false
})
export class RosterNamePipe implements PipeTransform {
    transform(value: string) {
        const newValue = value.split(" ");

        for (let i = 0, x = newValue.length; i < x; i++) {
            newValue[i] = newValue[i][0].toUpperCase() + newValue[i].substr(1);
        }

        return newValue.join(" ");
    }
}
